<template>
  <div class="contract-type">
    <div class="nav">
      <el-form :model="form" label-width="100px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="合同类型名称:">
          <el-input v-model="form.name" size="mini" placeholder="请输入合同名称"></el-input>
        </el-form-item>

        <el-form-item label="合同状态:">

          <el-select v-model="form.status" filterable size="mini" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用中" value="1"></el-option>
            <el-option label="禁用中" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <!-- <div class="exportButton"><span @click="exportData">导出数据</span></div> -->
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="contractName" label="合同类型名称" align="center"/>
          <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
          <el-table-column prop="createTime" label="添加时间" align="center">
            <template slot-scope="scope">
              {{scope.row.createTime | createTimeFormat}}
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.state == 1 ? "启用中" :"禁用中"}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px;justify-content: center;">
                <el-button  size="mini" type="danger" @click="DisableClick(scope.row.id, scope.row)" v-if="scope.row.state ==1 ">禁用</el-button>
                <el-button size="mini" type="primary" @click="EnableClick(scope.row.id, scope.row)" v-if="scope.row.state ==0 ">启用</el-button>
                <el-button size="mini" class="yellow-bg" @click="modifyClick(scope.row)">修改</el-button>
                <el-button size="mini" v-if="scope.row.sureDeleted==0" type="info" @click="deleteClick(scope.row)">删除</el-button>


              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>

    <el-dialog title="添加合同类型" :visible.sync="addflag" width='623px' center @close="dialogClose">
      <div class="add">
        <el-form :model="addform" label-width="100px"  :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="合同类型:" prop="type">
            <el-input size="mini"  v-model="addform.type" placeholder="请输入合同类型名称"></el-input>
          </el-form-item>
          <hr color="#F0F0F2"/>
          <el-form-item label="备注:">
            <el-input size="mini" v-model="addform.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <hr color="#F0F0F2"/>
        </el-form>
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick(1)">确认</el-button>
          <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
        </div>
      </div>


    </el-dialog>
    <el-dialog title="修改合同类型" :visible.sync="modifyflag" width='623px' center @close="dialogClose(2)">
      <div class="add">
        <el-form :model="modifyform" label-width="100px"  :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="合同类型:" prop="name">
            <el-input size="mini"  v-model="modifyform.name" placeholder="请输入合同类型名称"></el-input>
          </el-form-item>
          <hr color="#F0F0F2"/>
          <el-form-item label="备注:">
            <el-input size="mini" v-model="modifyform.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <hr color="#F0F0F2"/>
        </el-form>
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick(2)">添加</el-button>
          <el-button size="medium" class="resetBtn" @click="dialogClose(2)">关闭</el-button>
        </div>
      </div>


    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl
  } from "@/config/env";
  import { getSessionStore} from "@/config/mUtils"
  import {
    contractTypePageList,
    contractTypeUpdate,
    contractTypeAdd,
    contractTypeIsEnable,
    contractTypeDelete
  } from "@/service/contract";
  import {
    formatTime
  } from "@/config/mUtils";
  export default {
    components: {

    },

    data() {
      return {
        form:{
          name:"",
          status:"",
          page:1,
          rows:10,

        },
        total:0,
        tableLoad:false,
        TableDatas:[],
        addform:{
          type:'',
          remark:'',
        },
        modifyform:{
          name:'',
          remark:'',
        },
        DialogVisible:false,
        addflag:false,
        modifyflag:false,
        addLoad:false,
        modifyId:'',
        rules:{
          type:{ required: true, message: '请输入合同类型名称', trigger: 'blur' },
          name:{ required: true, message: '请输入合同类型名称', trigger: 'blur' },
        }
      };

    },
    filters:{
      createTimeFormat:function(value){
        console.log(value)
        if(value){
          return formatTime(value, "yyyy-mm-dd hh:ii:ss")
        }else {
          return ''
        }


      }
    },
    created() {
      this.$nextTick(()=>{
        this._contractTypePageList()
      })
    },
    methods: {
      //导出数据
      exportData(){
        const state = this.form.status;
        const contractName = this.form.name;
        let token = getSessionStore('token')
        window.location.href = `${baseUrl}/platform/contractType/export?access_token=${token}&state=${state}&contractName=${contractName}`
      },
      async _contractTypePageList(){
        this.tableLoad = true
        let res = await  contractTypePageList({
          ...this.form,
          contractName:this.form.name,
          state:this.form.status
        })
        this.tableLoad = false
        if (res.status !== 0){
          return  this.$message.error(res.message)
        }
        this.TableDatas = res.data.records
        this.total = res.data.total

      },
      searchBtn(){
        this.form.page = 1;
        this._contractTypePageList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ''
        }
        this.form.page = 1
        this.form.rows = 10

      },
      addBtn(){
        this.addflag = true
      },
      contractSizeChange(row){
        this.form.rows=row;
        this._contractTypePageList()
      },
      contractCurrentChange(page){
        this.form.page=page;
        this._contractTypePageList()
      },

      deleteClick(row){
        this.$confirm('确认要删除当前合同类型吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await contractTypeDelete(row.id);
          if (res.status !==0)   return  this.$message.error(res.message);
          this.$message.success(res.message);
          this._contractTypePageList()
        }).catch(() => {});
      },
      EnableClick(id,row){
        this.$confirm('确认要启用当前合同类型吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res =await contractTypeIsEnable(id)
          if (res.status!==0) {
            return  this.$message.error(res.message);

          }
          await this._contractTypePageList();
          this.$message.success(res.message);

        }).catch(() => {});
      },
      DisableClick(id,row){
        this.$confirm('确认要禁用当前合同类型吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
            let res =await contractTypeIsEnable(id)
          if (res.status!==0) {
            return  this.$message.error(res.message);
          }
          await this._contractTypePageList();
          this.$message.success(res.message);


        }).catch(() => {});
      },
      async addClick(flag){
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid){
            this.addLoad = true;
            if (flag ===1){
              let  res = await contractTypeAdd({
                contractName:this.addform.type,
                remarks:this.addform.remark
              })
              this.addLoad = false;
              if (res.status !==0){ return  this.$message.error(res.message); }
              this.$message.success(res.message);
              this._contractTypePageList()
              this.addflag = false
              this.clearData(1)
            }else {
              let  res2 = await contractTypeUpdate({
                contractName:this.modifyform.name,
                remarks:this.modifyform.remark,
                id:this.modifyId
              })
              this.addLoad = false;
              if (res2.status !==0){ return  this.$message.error(res2.message); }
              this.$message.success(res2.message);
              this._contractTypePageList()
              this.modifyflag = false
              this.clearData(2)
            }
          }else {
            console.log('error submit!!');
          }
        })

      },
      //清除数据
      clearData(flag){
        if (flag ===1){
          for (let addformKey in this.addform) {
            this.addform[addformKey]=''
          }
        }else {
          for (let modifyformKey in this.modifyform) {
            this.modifyform[modifyformKey] = ''
          }
        }
      },
      dialogClose(flag){
        if (flag===2){
          this.modifyflag = false
          for (let modifyformKey in this.modifyform) {
            this.modifyform[modifyformKey] = ''
          }
        }else {
          this.addflag = false
          for (const argumentsKey in this.addform) {
            this.addform[argumentsKey] = ''
          }
        }

      },
      modifyClick(row){
            this.modifyflag = true
        this.modifyform.name = JSON.parse(JSON.stringify(row.contractName))
        this.modifyform.remark = JSON.parse(JSON.stringify(row.remarks))
        this.modifyId = row.id
      },
    },
  };
</script>



<style lang="scss" scoped>
  .contract-type{
    /*width:100%;*/
    padding:20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .exportButton{
      text-align: end;
      span{
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;
        &:hover{
          cursor: pointer;
        }
      }
    }
    .nav{
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{
      .tableContainer{
        margin-bottom: 25px;
        ::v-deep{
          .el-table .cell {
            padding: 0;
          }
          .el-table th{
            padding: 0;
          }
          .el-table td{
            padding: 0;
          }
          .el-table th>.cell{
            font-weight: 700!important;
          }
        }
      }
    }
    ::v-deep.add{
      padding: 26px 40px;
      .el-input{
        width: 280px;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        /*color: #060606;*/
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom: 0px;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;
      button{
        margin: 0 15px;
      }
    }

  }
  ::v-deep{

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
    }


  }
</style>
